import React, { useContext, useEffect, useMemo, useState } from 'react';
import shallowequal from 'shallowequal';
import StyleSheet from '../sheet';
import createStylisInstance from '../utils/stylis';
export var mainSheet = new StyleSheet();
export var mainStylis = createStylisInstance();
export var StyleSheetContext = React.createContext({
    shouldForwardProp: undefined,
    styleSheet: mainSheet,
    stylis: mainStylis,
});
export var StyleSheetConsumer = StyleSheetContext.Consumer;
export var StylisContext = React.createContext(undefined);
export var StylisConsumer = StylisContext.Consumer;
export function useStyleSheetContext() {
    return useContext(StyleSheetContext);
}
export function StyleSheetManager(props) {
    var _a = useState(props.stylisPlugins), plugins = _a[0], setPlugins = _a[1];
    var styleSheet = useStyleSheetContext().styleSheet;
    var resolvedStyleSheet = useMemo(function () {
        var sheet = styleSheet;
        if (props.sheet) {
            sheet = props.sheet;
        }
        else if (props.target) {
            sheet = sheet.reconstructWithOptions({ target: props.target }, false);
        }
        if (props.disableCSSOMInjection) {
            sheet = sheet.reconstructWithOptions({ useCSSOMInjection: false });
        }
        return sheet;
    }, [props.disableCSSOMInjection, props.sheet, props.target, styleSheet]);
    var stylis = useMemo(function () {
        return createStylisInstance({
            options: { namespace: props.namespace, prefix: props.enableVendorPrefixes },
            plugins: plugins,
        });
    }, [props.enableVendorPrefixes, props.namespace, plugins]);
    useEffect(function () {
        if (!shallowequal(plugins, props.stylisPlugins))
            setPlugins(props.stylisPlugins);
    }, [props.stylisPlugins]);
    var styleSheetContextValue = useMemo(function () { return ({
        shouldForwardProp: props.shouldForwardProp,
        styleSheet: resolvedStyleSheet,
        stylis: stylis,
    }); }, [props.shouldForwardProp, resolvedStyleSheet, stylis]);
    return (React.createElement(StyleSheetContext.Provider, { value: styleSheetContextValue },
        React.createElement(StylisContext.Provider, { value: stylis }, props.children)));
}
//# sourceMappingURL=StyleSheetManager.js.map